import { adapter as programCardAdapter } from '@molecules/ProgramCard';

export default (props) => programCardAdapter(props);
